import { useState, useEffect } from "react";
import {
  Box,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Container, Draggable } from "react-smooth-dnd";
import { arrayMove } from "react-sortable-hoc";
import { useLocation, useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { rsScrollContent, rsParentCom } from "../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../hooks/useBreakpoints";

export default function MagPageContentRows(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [msScrollContent, setMsScrollContent] = useRecoilState(rsScrollContent);
  const [openDialog, setOpenDialog] = useState({
    show: false,
    id: undefined,
  });
  const [msParentCom, setMsParentCom] = useRecoilState(rsParentCom);
  const { isSmall } = useBreakpoints();

  const onDrop = ({ removedIndex, addedIndex }) => {
    const updater = (items) =>
      arrayMove(items, removedIndex, addedIndex).map((item, idx) => {
        return { ...item, rowIndex: idx + 1 };
      });
    props.setRow(updater);
  };

  useEffect(() => {
    if (props.row && msScrollContent) {
      const element = document.getElementById(msScrollContent);
      setTimeout(() => {
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 1500);
    }
  }, [location.state, props.row]);

  return (
    props.row && (
      <Container
        onDrop={onDrop}
        orientation="vertical"
        behaviour="move"
        style={{
          width: "100% !important",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        loading="lazy"
        dropPlaceholder={{
          animationDuration: 150,
          showOnTop: true,
          className: "cards-drop-preview",
        }}
      >
        {props.row.map((row, i) => {
          return (
            <Draggable
              loading="lazy"
              key={row.id}
              style={{
                width: "100%",
                cursor: "grab",
              }}
              id={row.id}
              order={i + 1}
            >
              <Box
                sx={{
                  border: "1px solid #d9d9d9",
                  p: 1,
                  borderRadius: 3,
                  width: isSmall ? "90%" : "40% !important",
                  mx: "auto",
                  maxWidth: "100%",
                  height: "auto",
                  minHeight: "130px",
                  mb: 2,
                  display: "flex",
                  alignItems: "flex-end",
                  position: "relative",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    display: "flex",
                    // justifyContent: "flex-start",
                    // alignItems: "flex-start",
                    zIndex: 1000,
                    left: 10,
                    top: 10,
                    width: "100% !important",
                    // height: "100%",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ borderRadius: 1, p: 0.5, bgcolor: "#aa00ff45" }}
                  >
                    {row.rowIndex} - {row.componentFaTitle}
                  </Typography>
                  {/* <Typography
                    variant="body2"
                    sx={{
                      borderRadius: 1,
                      ml: 1,
                      p: 0.5,
                      bgcolor: "#aa00ff45",
                    }}
                  >
                    {row.componentFaTitle}
                  </Typography> */}
                </Box>
                <LazyLoadImage
                  height="auto"
                  effect="blur"
                  src={row.image ? row.image : "/static/img/nobanner.png"}
                  width="100%"
                />
                <Box
                  sx={{
                    position: "absolute",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                    zIndex: 1000,
                    right: 5,
                    width: "100% !important",
                    height: "100%",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      var bool;
                      if (row.isActive == true) {
                        bool = false;
                      } else {
                        bool = true;
                      }
                      let newArr = props.row && props.row.slice();
                      newArr.find((m) => m.id == row.id).isActive = bool;
                      props.callback(newArr);
                    }}
                    sx={{
                      mr: 1,
                      p: 0.7,
                      bgcolor:
                        props.row.find((m) => m.id == row.id).isActive == true
                          ? "primary.main"
                          : "#A7A9AC",
                      "&:hover": {
                        bgcolor:
                          props.row.find((m) => m.id == row.id).isActive == true
                            ? "primary.main"
                            : "#A7A9AC",
                      },
                    }}
                  >
                    <VisibilityIcon fontSize="small" sx={{ fill: "#fff" }} />
                  </IconButton>
                  <IconButton
                    onClick={(evt) => {
                      setMsParentCom({
                        backUrl: "/magmanagment",
                        parentComs: "/magmanagment",
                      });

                      setMsScrollContent(row.id);
                      if (
                        row.componentTitle == "mainslider" ||
                        row.componentTitle == "mainslider2" ||
                        row.componentTitle == "mainslider3" ||
                        row.componentTitle == "mainslider4" ||
                        row.componentTitle == "mainslider5"
                      ) {
                        return navigate("/magmanagment/SlidesManage", {
                          state: {
                            SlideID: row.id,
                            ComponentID: row.componentID,
                            componentFaTitle: row.componentFaTitle,
                          },
                        });
                      } else {
                        return navigate("/magmanagment/LandingsManage", {
                          state: {
                            LandingID: row.id,
                            componentFaTitle: row.componentFaTitle,
                          },
                        });
                      }
                    }}
                    sx={{
                      p: 0.7,
                      mr: 1,
                      bgcolor: "secondary.main",
                      "&:hover": {
                        boxShadow: 3,
                        bgcolor: "secondary.main",
                      },
                    }}
                  >
                    <EditIcon fontSize="small" sx={{ fill: "#fff" }} />
                  </IconButton>
                  <IconButton
                    sx={{
                      p: 0.7,
                      bgcolor: "secondary.main",
                      "&:hover": {
                        boxShadow: 3,
                        bgcolor: "secondary.main",
                      },
                    }}
                    onClick={() => {
                      setOpenDialog({ show: true, id: row.id });
                    }}
                  >
                    <DeleteIcon fontSize="small" sx={{ fill: "#fff" }} />
                  </IconButton>
                </Box>
              </Box>
            </Draggable>
          );
        })}
        <Dialog
          PaperProps={{
            elevation: 1,
          }}
          fullWidth
          open={openDialog.show}
          onClose={() => setOpenDialog({ ...openDialog, show: false })}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            آیا از حذف این آیتم اطمینان دارید ؟
          </DialogTitle>
          <DialogActions>
            <Button
              sx={{ color: "#565656 !important" }}
              onClick={() => {
                let rows = props.row && props.row.slice();
                var newList = rows.filter((b) => b.id !== openDialog.id);
                props.callbackRemove(openDialog.id);
                setOpenDialog({ ...openDialog, show: false });
              }}
            >
              بله
            </Button>
            <Button
              color="secondary"
              onClick={() => setOpenDialog({ ...openDialog, show: false })}
            >
              خیر
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    )
  );
}
